import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lending-team',
  templateUrl: './lending-team.component.html',
  styleUrls: ['./lending-team.component.scss']
})
export class LendingTeamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
